import config from 'react-global-configuration';
export function isExternalLink() {
  var uri = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var value = uri.trim().replace(/\/$/, '');
  if (/^(https?|mailto|tel):/g.test(value)) {
    return true;
  }
  return false;
}
export function isHashLink() {
  var uri = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var value = uri.trim().replace(/\/$/, '');
  if (/^#/g.test(value)) {
    return true;
  }
  return false;
}
export function normalizeLink(link) {
  var API_URL = config.get('API_URL');
  if (/^\//g.test(link)) {
    return "".concat(API_URL).concat(link);
  }
  return link;
}